import React from "react";

const categories = [
  "All",
  "Fitness",
  "Technology",
  "Arts",
  "Artificial Intelligence",
  "Sports",
  "International",
  "Insights",
  "Career",
];

const CategoryTabs = ({ category, setCategory }) => {
  return (
    <div className="home-categories">
      {categories.map((label) => {
        const isActive = category === label;

        return (
          <button
            key={label}
            className={`home-category-pill${isActive ? " active" : ""}`}
            onClick={() => setCategory(label)}
            type="button"
            style={{
              padding: "6px 16px",
              borderRadius: "100px",
              fontSize: "12px",
              fontWeight: 500,
              cursor: "pointer",
              border: `1.5px solid ${isActive ? "var(--home-ink)" : "var(--home-border)"}`,
              background: isActive ? "var(--home-ink)" : "transparent",
              color: isActive ? "var(--home-cream)" : "var(--home-muted)",
              transition: "all .2s",
              letterSpacing: "0.03em",
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryTabs;
